async function putPastedExternalContent(editor, content, meta) {
  const point = meta.point ?? ("point" in content ? content.point : void 0);
  if (editor.options.onBeforePasteFromClipboard) {
    const result = await editor.options.onBeforePasteFromClipboard({
      editor,
      content,
      source: meta.source,
      point
    });
    if (result === false) return;
    if (result != null) content = result;
  }
  return editor.putExternalContent(content);
}
export {
  putPastedExternalContent
};
//# sourceMappingURL=putPastedContent.mjs.map
